export default "__VITE_ASSET__WPGYjwIlzWVNM1bYhOc83w__"